export const ID_DESCARGA_PDF = -1;
